<script setup lang="ts">
import { trans } from '../../../../_00_elements/translation';

defineProps<{ status: string }>();
</script>

<template>
  <div class="subscription-status-tag" :class="`subscription-status-tag__${status}`">
    {{ trans(`gestion.subscription.status.${status}`) }}
  </div>
</template>

<style scoped lang="scss">
@use '@styles/variables' as *;
@use '@styles/mixins' as *;

.subscription-status-tag {
  @include fontBodySmallBold;
  border-radius: rem(8);
  padding: rem(2) rem(4);
  width: fit-content;
  margin-right: rem(16);

  &__active {
    color: $colorGreen;
    background-color: $colorGreenLighter;
  }

  &__inactive, &__terminated, &__unrecoverable, &__voided {
    color: $colorWhite;
    background-color: $colorGrayDark;
  }

  &__programmed, &__partially_paid {
    color: $colorBlue;
    background-color: $colorBlueLighter;
  }
}
</style>
